import React from 'react';
import './Stepper.scss';
import { CreatePersonPayload } from 'services/person/person.types';

export type StepperProps = {
    steps: Array<string>;
    activeStep: number;
    setActiveStep: (step: number) => void;
    handlePreviousStep: (data: CreatePersonPayload) => void;
} & React.ComponentPropsWithoutRef<'div'>;

export const Stepper: React.FC<StepperProps> = ({ steps, activeStep, setActiveStep, handlePreviousStep }) => {
    return (
        <div className="stepper" key={activeStep}>
            <div className="steps">
                {steps &&
                    steps?.map((step, index) => (
                        <div
                            key={index}
                            className={`step ${activeStep === index + 1 ? 'active' : ''} ${activeStep > index + 1 ? 'done' : ''}`}
                        >
                            <span className="number">{index + 1}</span>
                            <p className="title">{step}</p>
                        </div>
                    ))}
            </div>
        </div>
    );
};
